import { useMemo } from 'react'

import { MAPPED_CATEGORY_SLUGS } from 'interfaces/constants'

import { useRouterExtend } from './useRouterExtend'
export function getCategoryFromURL(
  url: string,
  categories: Record<keyof typeof MAPPED_CATEGORY_SLUGS['vi-VN'], string>,
): string | null {
  const urlParts = url.split('/')

  for (const key in categories) {
    const keyword = categories[key]
    if (urlParts.includes(keyword)) {
      return key
    }
  }

  return null // Return null if no matching key is found
}

export const useCategory = () => {
  const { asPath, locale } = useRouterExtend()

  const type = useMemo<string | null>(() => {
    return getCategoryFromURL(asPath, MAPPED_CATEGORY_SLUGS[locale])
  }, [asPath, locale])
  return {
    isSexualWellness: type === 'sexualWellness',
    isPregnancy: type === 'pregnancy',
    isParenting: type === 'parenting',
    isHeartHealth: type === 'heartHealth',
    isHealth: type === 'health',
    type,
  }
}
